import { UserBadgeIconComponent } from "assets/icons";
import LockedFeature from "../../LockedFeature";
import { truncate } from "utils/text";
import useTranslation from "hooks/useTranslation";

const PLACEHOLDER_TEXT = "--";

function UserDetailsBox({
  userInfo,
  departmentName,
  totalTimeSpent,
  lastOperatorInConversation,
  userRoadmapEnabled,
}) {
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const { ip, browser, lastPage } = userInfo;
  const browserName = browser?.name || "";
  const browserVersion = browser?.ver || "";
  const os = browser?.os;

  // renders page addresses in user-info card that user has messaged from (last page) and has been before being navigated into the site (referrer)
  const renderLink = (url) => (
    <a href={url} rel="noreferrer" target="_blank">
      {truncate(url, 32)}
    </a>
  );

  const infoArray = [
    ...(lastOperatorInConversation
      ? [
          {
            id: "operator",
            label: t("OPERATOR_NAME"),
            content: lastOperatorInConversation?.name || PLACEHOLDER_TEXT,
          },
        ]
      : []),
    {
      id: "department",
      label: t("DEPARTMENT"),
      content: departmentName,
    },
    {
      id: "timeSpent",
      label: t("TIME_SPENT_IN_WEBSITE"),
      content: !userRoadmapEnabled ? (
        <LockedFeature text="قفل" />
      ) : (
        totalTimeSpent || PLACEHOLDER_TEXT
      ),
    },
    {
      id: "ip",
      label: t("IP"),
      content: ip,
    },
    {
      id: "device",
      label: t("DEVICE"),
      content: os,
    },
    {
      id: "browser",
      label: t("BROWSER"),
      content: `${browserName} ${browserVersion}`.trim(),
    },
    {
      id: "lastPage",
      label: t("PAGE"),
      content: renderLink(lastPage),
    },
    {
      id: "referral",
      label: t("REFERRAL"),
      content: renderLink(browser?.referrer),
    },
  ];

  return (
    <div className="conv__userinfo__card">
      <div className="conv__userinfo__card__title flex flex-ai-c flex-columngap-8">
        <UserBadgeIconComponent className="user_badge_icon" />
        <h3 className="user_infos_title"> {t("USER_INFOS")} </h3>
      </div>
      <div className="conv__userinfo__card__propertyerty">
        <div className="conv__userinfo__card__property__fields">
          <div className="conv__userinfo__card__property__fields__inner ">
            {infoArray.map((item) => (
              <div
                key={item.id}
                className="conv__userinfo__card__property__fields__inner__row flex flex-ai-c"
              >
                <div className="conv__userinfo__card__property__fields__inner__row__title no-flex">
                  {item.label}
                </div>
                <div className="conv__userinfo__card__property__fields__inner__row__value">
                  {item.content || PLACEHOLDER_TEXT}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetailsBox;
